<template>
    <div class="history-list"
        v-if="isLoaded">
        <div class="history-list-content"
            v-if="isHaveItem">
            <EarnItem
                v-for="(earn, index) in list"
                :key="index"
                :index="index"
                :lbl="lbl"
                :item="earn"
                :productMaster="productMaster"/>
        </div>
        <EmptyList
            :lbl="lbl"
            v-if="!isHaveItem" />
    </div>
</template>
<script>
//helper
import Account from '@/helper/AccountHelper.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
//component
import EarnItem from './EarnItem.vue';
import EmptyList from './EmptyList.vue';
//service
//import { HistoryPointConfigBuilder } from '@/core/Point/model/PointConfigModel.js';
import BzbsPoint from '@/core/Point/service/BzbsPoint.js';
import ProductPointConfig from "@/core/ProductPointDetail/ProductPointConfig.js";

export default {
    name: 'EarnList',
    components: {
        EarnItem,
        EmptyList
    },
    props: {
        lbl: Object,
        initListConfig: Object,
        busEvent: Object
    },
    data: function () {
        return {
            list: [],
            listConfig: {},
            listAmount: 7,
            isHaveItem: false,
            isLoaded: false,
            isLoading: false,
            isListLoading: false,
            isLoadMore: true,
            lastRowKey: '',

            productMaster: null,
            tracking: new TrackingService(this)
        };
    },
    created: function () {
        this.listConfig = this.initListConfig;

        this.getProductMaster();
        this.tracking.screenName('History_Point_Earn_Page');
        this.tracking.event('History_Point_Earn', 'Click_History_Point_Earn');
    },
    mounted: function() {
        this.getList();
        this.initialSeeMore();
        this.busEvent.$on("reInitList", this.reInitialList);
        // this.scrollObserver.subscribe(isBottom => {
        //     if (isBottom)
        //         this.loadMore(isBottom);
        // });
    },
    beforeDestroy: function() {
        window.onscroll = function() {};
        this.busEvent.$off("reInitList");
    },
    methods: {
        //initial
        initialSeeMore: function () {
            window.onscroll = () => {
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );

                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow) {
                    this.loadMore();
                }
            }
        },
        getList: function (lastRowKey) {
            if(!this.isLoadMore) return;
            if (this.isListLoading) return;

            this.showLoading();

            var token = Account.getToken();
            if(lastRowKey){
                this.listConfig.strLastRowKey = lastRowKey;
            }

            this.isListLoading = true;
            var defaultTopAmount = this.listConfig.defaultTopAmount;

            console.log('list', this.listConfig)
            //var params = this.listConfig.create().getParams();

            BzbsPoint.apiGetPointHistory(token, this.listConfig)
                .subscribe(res => {
                    this.listConfig.intSkip += defaultTopAmount;

                    if (res && res.length < this.listConfig.defaultTopAmount){
                        this.listConfig.isSeeMoreEnable = false;
                        this.isLoadMore = false;
                    }

                    if (this.listConfig.intSkip == defaultTopAmount)
                        this.list = [];

                    //select trace
                    var earns = res.filter(point => {
                        return point.type != "redeem";
                    });

                    if (this.list.length == 0) {
                        this.list = [...earns];

                        //this.earns = res;
                    } else {
                        for (let earn of earns) {
                            this.list.push(earn);
                        }
                    }

                    console.log('list', this.list)
                    this.isHaveItem = (this.list.length > 0);

                    this.isLoaded = true;
                    this.isListLoading = false;
                    this.hideLoading();
                    console.log(res);

                }, err => {
                    this.isLoaded = true;
                    this.isListLoading = false;
                    this.hideLoading();
                    console.log(err);
                });
        },
        loadMore: function () {
            if (!this.listConfig.isSeeMoreEnable) return;

            setTimeout(() => {
                if(this.listConfig.isSeeMoreEnable){
                    console.log(this.list[this.list.length - 1].rowKey)
                    this.lastRowKey = this.list[this.list.length - 1].rowKey;
                }
                this.getList(this.lastRowKey);
            }, 500);
        },
        reInitialList: function(data) {
            this.resetLoaded();
            this.listConfig = data.listConfig;
            this.getList();
        },
        resetLoaded: function() {
            this.list = [];
            this.isLoading = false;
            this.isLoaded = false;
            this.isHaveItem = false;
            this.isLoadMore = true;
            this.listConfig.strLastRowKey = null;
        },
        getProductMaster: function(){
            ProductPointConfig.apiGetProductMaster().subscribe(res =>{
                //console.log('product', res);
                this.productMaster = res;
            });
        },
        //utility
        showLoading: function () {
            if (this.isLoading) return true;

            this.toggleLoading(true);
            return false;
        },
        hideLoading: function () {
            this.toggleLoading(false);
        },
        toggleLoading: function (isLoading) {
            this.$emit('toggleLoading', isLoading);
        },
    }
}
</script>

